import React, { useState, useEffect } from 'react';
import Launcher from '@/components/Launcher';

const DefaultLauncher = ({ pastDelay }) => <Launcher type="loading" pastDelay={pastDelay} />;

const Loading = ({ delay = 200, Component = DefaultLauncher }) => {
  const [pastDelay, setPastDelay] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setPastDelay(true);
    }, delay);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [delay]);
  return pastDelay ? <Component pastDelay={pastDelay} /> : null;
};

export default Loading;
